import axios from 'axios';
import {CikeGetScreenSinglePretty} from '@/maps/pretty/course';

/**课程相关接口*/
export class CourseApi {
  getScreenSingle(params?: { start_time?: string; end_time?: string; week?: Array<number>; curriculum_id?: Array<number>; store_id?: Array<number>; date?: string; }) {
    return axios.get<CikeGetScreenSinglePretty>('/api/course/list', {params: params});
  }
}
